import Nullstack from 'nullstack';
export default function IconPokerChip({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-poker-chip",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v4"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M18.364 5.636l-2.828 2.828"
  }), "   ", Nullstack.element("path", {
    d: "M8.464 15.536l-2.828 2.828"
  }), "   ", Nullstack.element("path", {
    d: "M5.636 5.636l2.828 2.828"
  }), "   ", Nullstack.element("path", {
    d: "M15.536 15.536l2.828 2.828"
  }), " ");
}